


























import { defineComponent, PropType, ref } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import { ListFields } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseInputRadio from "@/components/BaseInputRadio";
import { TaxFormDraft } from "../../../types";

export default defineComponent({
  name: "ResidenceForm",
  components: { BaseButton, BaseConfirm, BaseInputRadio },
  props: {
    draft: { type: Object as PropType<TaxFormDraft | null>, default: null },
  },
  setup(props, { emit, root }) {
    const residence = ref<"yes" | "no" | null>(
      props.draft?.residesInUsaOrCanada === undefined ? null : props.draft.residesInUsaOrCanada ? "yes" : "no"
    );
    const showUnavailable = ref(false);

    const residenceOptions: ListFields = [
      { text: $t("Yes"), value: "yes" },
      { text: $t("No"), value: "no" },
    ];

    const onRadioInput = (value: "yes" | "no") => {
      residence.value = value;
      emit("updateDraft", { residesInUsaOrCanada: value === "yes" });
      emit("setValid", value === "yes");
      if (value === "no") showUnavailable.value = true;
    };

    const returnToHome = () => {
      root.$router.push({ name: "home" });
    };

    emit("setValid", residence.value === "yes");

    return { residence, residenceOptions, showUnavailable, onRadioInput, returnToHome };
  },
});
